module.exports = __webpack_public_path__ + "static/media/privacypolicy_sinhala.e1d5911b.md";